import { SortByType } from "stores/search/types"

export const WHIMSTAY_APP_URL_IN_APPLE_STORE =
  "https://apps.apple.com/us/app/whimstay-vacation-rentals/id1439647360"

export const WHIMSTAY_APP_URL_IN_PLAY_STORE =
  "https://play.google.com/store/apps/details?id=com.wemaste"

export const WHIMSTAY_MEDIA_EMAIL = "media@whimstay.com"
export const WHIMSTAY_SUPPORT_EMAIL = "support@whimstay.com"

export const WHIMSTAY = "whimstay"

export const AVAILABLE_COUNTRIES_FOR_LOGIN = [
  // North America
  "us", // United States
  "ca", // Canada
  "mx", // Mexico
  "gb", // United Kingdom
  "ie", // Ireland
  "au", // Australia
  "nz", // New Zealand
  "za", // South Africa

  // "ar", // Argentina
  // "bo", // Bolivia
  // "br", // Brazil
  // "cl", // Chile
  // "co", // Colombia
  // "ec", // Ecuador
  // "gy", // Guyana
  // "py", // Paraguay
  // "pe", // Peru
  // "sr", // Suriname
  // "uy", // Uruguay
  // "ve", // Venezuela

  // "de", // Germany
  // "es", // Spain
  // "fi", // Finland
  // "ch", // Switzerland
  // "it", // Italy
  // "pt", // Portugal
  // "cz", // Czechia / Czech Republic
  // "se", // Sweden
  // "dk", // Denmark
  // "lu", // Luxembourg
  // "nl", // Netherlands
  // "pl", // Poland
  // "no", // Norway
  // "fr", // France
  // "si", // Slovenia
  // "be", // Belgium
  // "hr", // Croatia
  // "at", // Austria
  // "hu", // Hungary
  // "sk", // Slovakia
]
export const CONTACT_AREA_SERVED = ["US", "MX", "CAN"]
export const ABOUT_SPECIALTY = [
  "Last-Minute Vacation Rentals",
  "Exclusive Travel Discounts",
  "Property Management Partnerships",
  "Affordable Luxury Stays",
]

export const AVAILABLE_LANGUAGE_FOR_CONTACT = ["English", "Spanish"]
export const PAYMENT_METHODS = [
  "Credit Card",
  "Apple Pay",
  "Google Pay",
  "Affirm",
]

export const NO_OF_PROERTIES_PER_PAGE_IN_LISTING_PAGE = 21
export const FALLBACK_LOGO_IMAGE = "/assets/images/signature_logo.png"

export const TRAVEL_AGENT_ROLE = "TRAVEL_AGENT"

export const USER_ROLE_ALLOW_HOST_FEES = ["DEVELOPER", "AMADMIN", "AMUSERADMIN"]

export const USER_ROLE_ALLOW_PRECISION_PRICING = [
  "ROOTADMIN",
  "ADMIN",
  "TAADMIN",
  "AMADMIN",
  "TAUSERADMIN",
  "AMUSERADMIN",
  "DEVELOPER",
  "MARKETINGADMIN",
  "RBOADMIN",
]

export const SORT_KEY_VALUE_MAPPING = {
  highToLow: "Price: high to low",
  lowToHigh: "Price: low to high",
  highToLowGuest: "Sleeps: high to low",
  lowToHighGuest: "Sleeps: low to high",
  bestDeals: "Total % Discount",
  biggestSavings: "Total $ Savings",
  nightlyPrice: "Nightly Price",
  totalTripCost: "Total Trip Cost",
  recommended: "Best value",
  guestRatings: "Guest rating",
}

export const SORT_KEY_MAPPING = {
  highToLow: "highToLow",
  lowToHigh: "lowToHigh",
  bestDeals: "bestDeals",
  biggestSavings: "biggestSavings",
  recommended: "recommended",
  guestRatings: "guestRatings",
}

export const defaultSortByValue = SORT_KEY_MAPPING.highToLow as SortByType

export const clearedSortingState = {
  highToLow: false,
  lowToHigh: false,
  bestDeals: false,
  biggestSavings: false,
  recommended: false,
  guestRatings: false,
}

export const RECOMMENDED_DEALS_TYPE_CODE = "Recommended deals"
export const FEATURE_TYPE_CODE = "Featured"
export const PROPERTY_CARD_SECTION_TYPE_CODE = "Property Card Section"

export const ELITE_PACIFIC_PMC_ID = "elitepacific"
export const DURKIN_COTTAGES_PMC_ID = "v3cdcr0208"

export const MIN_RISK_RATING = 50
export const MAX_RISK_RATING = 75

export const WHIMSTAY_PROD_URL_S3_AMAZONAWS =
  "https://whimstay-production-assets.s3.amazonaws.com"
export const WHIMSTAY_PROD_URL_S3_US_EAST_AMAZONAWS =
  "https://whimstay-production-assets.s3.us-east-1.amazonaws.com"

export const MAP_AREA = "map area"

export const PMS_SYSTEM_WHIMSTAY = "whimstay"

export enum UnitsFilters {
  ALL = "All",
  STUDIO = "Studio",
  ONE_BED = "1 Bed",
  TWO_BED = "2 Beds",
  THREE_BED = "3 Beds",
  THREE_PLUS_BED = "3+ Beds",
}

export enum CancellationPolicyType {
  PARTIAL = "Partial",
  STANDARD = "Standard",
  MODERATE = "Moderate",
  STRICT = "Strict",
}

// channel messages filter types
export const messageFilterTypes = [
  { value: "all", title: "All" },
  { value: "inquiry", title: "Pre-booking" },
  { value: "confirmed", title: "Active booking" },
  { value: "Past Booking", title: "Past booking" },
]

export const CANCEL_BOOKING_STATUS = "cancel"
export const CANCELLATION_POLICY_TEXT = "This reservation is non-refundable."

export const LIST_YOUR_PROPERTY_LINK =
  "https://www.whimstay.com/blog/list-your-properties/"

export enum PDPPageOrigins {
  search = "search results page",
  LINK = "open via link",
}
